var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-container',{staticStyle:{"height":"100vh"}},[_c('el-header',[_c('custom-header')],1),_c('el-container',{staticClass:"layout_content"},[_c('el-aside',{attrs:{"width":"180"}},[_c('custom-menu')],1),_c('el-main',[_c('router-view',{key:_vm.$route.fullPath})],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }